import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { misc } from "app/themes/colors";

type ChartNotesStyleTabLabelProps = {
  label: string;
  isActive: boolean;
  count?: number;
  /** Shows a dot after the label, meaning "this tab holds content". */
  hasContent?: boolean;
};

export default function ChartNotesStyleTabLabel({
  label,
  isActive,
  count,
  hasContent
}: ChartNotesStyleTabLabelProps) {
  return (
    <Stack direction="row" alignItems="center" gap={0.75}>
      <Typography
        variant="body2"
        className={!isActive ? "tabText" : undefined}
      >
        {label}
      </Typography>
      {hasContent && (
        // Sits inside the Stack rather than as an anchored `Badge`: this tab list paints its
        // buttons white and gives the selected tab a 1px border, which clips a badge anchored
        // over the corner (the reason `NotificationTab` and `TaskTabLabel` both carry
        // `zIndex: 0` overrides). `role="img"` appends the label to the tab's accessible name
        // so the state is not conveyed by shape alone.
        <Box
          component="span"
          role="img"
          aria-label="has content"
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            flexShrink: 0,
            bgcolor: misc.sunoGreen
          }}
        />
      )}
      {count !== undefined && (
        <Chip
          label={count}
          size="small"
          sx={{
            height: 18,
            fontSize: "0.7rem",
            pointerEvents: "none",
            background: isActive ? undefined : misc.sunoGreen,
            color: isActive ? undefined : "white"
          }}
        />
      )}
    </Stack>
  );
}
